import { render } from "./DateRanges.vue?vue&type=template&id=4fa6945e"
import script from "./DateRanges.vue?vue&type=script&lang=js"
export * from "./DateRanges.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__